<template>
  <div>
    <DataTableAG
      :columns="columns"
      :getcontentpath="getnotificationspath"
      jsonobject="notificationsextra"
      :buttonList="['Muokkaa']"
      v-on:pressed-button1="editNotification"
      width="700px"
      height="750px"
      archivecontentpath="2.0/newbe/deletenotifications"
      archiveparam="notificationids"
    />
  </div>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
export default {
  name: "Notifications",
  components: {
    DataTableAG,
  },
  methods: {
    editNotification(rowData) {
      this.$router.push("/addnotificationsextra/" + rowData.id);
    },
  },
  data: () => ({
    getnotificationspath: "/1.0/front/notificationsextra",
    archivenotificationpath: "/1.0/front/archivenotificationextra",
    columns: [
      {
        field: "title",
        headerName: "Otsikko",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "unionmember_id",
        headerName: "Liitto",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "archived",
        headerName: "Poistettu",
        width: 125,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "created",
        headerName: "Lähetyshetki",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "count",
        headerName: "Nähty",
        width: 100,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  mounted() {},
};
</script>
